module.exports = __webpack_public_path__ + "static/media/faq.21420190.gif";